
import { Component, Prop, Vue } from 'vue-property-decorator'
import PanelFrame from '@/components/molecules/PanelFrame.vue'
import LearningProgressTip from '@/components/organisms/LearningProgressTip.vue'
import { StudyCategoryCurriculumUnit } from '@/models/CurriculumUnit'

/**
 * 教材選択ページのコンテンツ
 */
@Component({
  components: {
    PanelFrame,
    LearningProgressTip,
  },
})
export default class SelectStudyCategoryContent extends Vue {
  /** 学習教材選択ページ用単元情報 */
  @Prop()
  private studyCategoryCurriculumUnit!: StudyCategoryCurriculumUnit

  /** パネルクリック時のイベント */
  @Prop()
  private eventClickPanel!: (curriculumUnitId: number) => void

  /**
   * 学習進捗の色指定
   *
   * @returns css指定
   */
  private get setStyle(): { [key: string]: string } {
    const learningProgress = this.studyCategoryCurriculumUnit.learningProgress
    return {
      '--color-learning-progress__text': `var(${learningProgress.color})`,
      '--color-learning-progress__background': `var(${learningProgress.colorBackGround})`,
    }
  }
}
